import esriConfig from "@arcgis/core/config.js";
import { useEffect, useState } from "react";
import "@arcgis/map-components/components/arcgis-scene";

import "@arcgis/map-components/components/arcgis-zoom";
import "@arcgis/map-components/components/arcgis-compass";
import "@arcgis/map-components/components/arcgis-home";
import "@arcgis/map-components/components/arcgis-search";
import "./view.css";
function View({ onChange }) {
  const [config, setConfig] = useState(false);

  useEffect(() => {
    esriConfig.portalUrl = "https://gis.brno.cz/esri";
    
    setConfig(true);
  }, []);

  useEffect(() => {
    const view = document.querySelector("#viewDiv");


    onChange(view);
  }, [config]);

  return (
    <>
      {config && (
        <arcgis-scene
          id="viewDiv"
          item-id="c175914ae54c4d878f20dc8b2382c7c0"
        >
           <arcgis-search id="searchWidget" position="manual" >
           </arcgis-search>
           <arcgis-zoom id="zoomWidget" position="top-right"></arcgis-zoom>
           <arcgis-compass id="compasWidget" position="bottom-right"></arcgis-compass>
           <arcgis-home position="top-left"  id="homeWidget" style={{ display: "none" }} ></arcgis-home>
        </arcgis-scene>
      )}
    </>
  );
}

export default View;
